"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// Common
var rest_1 = tslib_1.__importDefault(require("../../common/lib/client/rest"));
var realtime_1 = tslib_1.__importDefault(require("../../common/lib/client/realtime"));
var platform_1 = tslib_1.__importDefault(require("../../common/platform"));
// Platform Specific
var bufferutils_1 = tslib_1.__importDefault(require("./lib/util/bufferutils"));
// @ts-ignore
var crypto_1 = tslib_1.__importDefault(require("./lib/util/crypto"));
var http_1 = tslib_1.__importDefault(require("./lib/util/http"));
var config_1 = tslib_1.__importDefault(require("./config"));
// @ts-ignore
var transport_1 = tslib_1.__importDefault(require("./lib/transport"));
var logger_1 = tslib_1.__importDefault(require("../../common/lib/util/logger"));
var defaults_1 = require("../../common/lib/util/defaults");
var webstorage_1 = tslib_1.__importDefault(require("./lib/util/webstorage"));
var defaults_2 = tslib_1.__importDefault(require("./lib/util/defaults"));
var msgpack_1 = tslib_1.__importDefault(require("./lib/util/msgpack"));
var Crypto = (0, crypto_1.default)(config_1.default, bufferutils_1.default);
platform_1.default.Crypto = Crypto;
platform_1.default.BufferUtils = bufferutils_1.default;
platform_1.default.Http = http_1.default;
platform_1.default.Config = config_1.default;
platform_1.default.Transports = transport_1.default;
platform_1.default.WebStorage = webstorage_1.default;
rest_1.default.Crypto = Crypto;
realtime_1.default.Crypto = Crypto;
logger_1.default.initLogHandlers();
platform_1.default.Defaults = (0, defaults_1.getDefaults)(defaults_2.default);
if (platform_1.default.Config.agent) {
    // @ts-ignore
    platform_1.default.Defaults.agent += ' ' + platform_1.default.Config.agent;
}
/* If using IE8, don't attempt to upgrade from xhr_polling to xhr_streaming -
 * while it can do streaming, the low max http-connections-per-host limit means
 * that the polling transport is crippled during the upgrade process. So just
 * leave it at the base transport */
if (platform_1.default.Config.noUpgrade) {
    platform_1.default.Defaults.upgradeTransports = [];
}
exports.default = {
    Rest: rest_1.default,
    Realtime: realtime_1.default,
    msgpack: msgpack_1.default,
};
